import { ChipDenomination } from 'game-logic';
import { BlackjackAssetType } from '../../../model/blackjack-types';
import { GameServices } from '../../../services/game-services';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';

export interface ChipData {
  chip: ChipDenomination;
  asset: BlackjackAssetType;
}

export class ChipButtonControlViewModel {
  public get buttonAsset() {
    return this.gameServices.assetCatalogueService.getAsset(this.data.asset);
  }
  public get startButtonAnimation$() {
    return this.startButtonAnimation.asObservable().pipe(distinctUntilChanged());
  }

  private startButtonAnimation = new BehaviorSubject<boolean>(true);

  constructor(
    private gameServices: GameServices,
    private data: ChipData,
    private onClickCallback?: (amount: ChipDenomination) => void,
  ) {}

  public canDisplayForAmount(amount: number) {
    return this.data.chip <= amount;
  }

  public buttonClicked() {
    this.onClickCallback?.(this.data.chip);
  }

  public enableButtonAnimation(enable: boolean): void {
    this.startButtonAnimation.next(enable);
  }
}
